<div
  class="dialog d-flex direction-column align-center justify-space-between"
>
  <div
    class="dialog__header row direction-column"
    [ngClass]="{ header__tabs: dialogType === DialogTypeEnum.ViewContract }"
  >
    <div class="title pb-15">
      <span mat-dialog-title>{{ data.template?.title }}</span>
    </div>

    <ng-container *ngIf="dialogType === DialogTypeEnum.EditContract">
      <div class="description">
        <span>{{ data.template?.description }}</span>
      </div>
    </ng-container>

    <div class="action">
      <ng-container [ngSwitch]="dialogType">
        <ng-container *ngSwitchCase="DialogTypeEnum.AddContract">
          <div class="field-input input align-center d-flex">
            <app-svg-icon
              class="input-icon"
              width="15px"
              height="17px"
              color="white"
              src="assets/icons/search-icon.svg"
              alt="search"
            >
            </app-svg-icon>
            <input
              class="input-box box"
              type="text"
              placeholder="Buscar"
              [formControl]="searchField"
              (change)="handleSearchField()"
              (keyup.enter)="handleSearchField()"
            />
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="DialogTypeEnum.ViewContract">
          <app-tabs-navigation
            position="left"
            [tabs]="tabs"
            [type]="TabTypeEnum.Modal"
            (changeTabsEvent)="changeTabs($event)"
          ></app-tabs-navigation>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="dialog__body">
    <ng-container [ngSwitch]="dialogType">
      <ng-container *ngSwitchCase="DialogTypeEnum.EditContract">
        <app-lots-group-dialog
          #lotsGroup
          [lotsList]="lotsList"
          [lotOrigin]="lotActive"
          [typeLot]="typeLot"
          [originalContractIds]="originalContractIds"
        >
        </app-lots-group-dialog>
      </ng-container>
      <ng-container *ngSwitchCase="DialogTypeEnum.AddContract">
        <app-list-contracts-dialog
          #listContract
          [lotOrigin]="lotActive"
          [contractsInLots]="contractsInLots ?? []"
          [typeLot]="typeLot"
        >
        </app-list-contracts-dialog>
      </ng-container>
      <ng-container *ngSwitchCase="DialogTypeEnum.ViewContract">
        <app-generate-lots-dialog
          class="fade-in"
          [lot]="lotsDetailList[0]"
          [typeLot]="typeLot"
        ></app-generate-lots-dialog>
      </ng-container>
    </ng-container>
  </div>

  <div class="dialog__footer row align-center justify-space-between">
    <button class="btn__back ui-btn ui-btn--secondary" [mat-dialog-close]="false">Voltar</button>
    <button
      class="btn__action ui-btn ui-btn--primary"
      [disabled]="disableGenerateLots"
      [ngClass]="{ opacity: disableGenerateLots }"
      (click)="submitModal()"
    >
      {{ data.template?.textConfirmButton }}
    </button>
  </div>
</div>
